import React, { useEffect, useState } from "react";
import AddToCartModal from "./AddToCartModal";
import {
  formatUSAmount,
  getSelectionMethod,
  islessthan3days,
} from "../../utils/helperFunctions/helperFunctions";
import { useSelector } from "react-redux";
import { getSuppCartAddCondition } from "../../utils/helperFunctions/supplements";

const SupplementCard = ({ supplement }) => {
  const [showAddToCartModal, setShowAddToCartModal] = useState(false);
  const bookingDetails = useSelector((state) => state.bookingValidation.data);
  const cartData = useSelector((state) => state.cart.cartItems);
  const [itemAdded, setItemAdded] = useState(false);

  var { min_qty, max_qty, guest_count, child_count } = getSuppCartAddCondition(
    bookingDetails,
    supplement.Selection_method
  );

  if (supplement.child?.Selection_method) {
    var { child_min_qty, child_max_qty } = getSuppCartAddCondition(
      bookingDetails,
      supplement.child.Selection_method
    );
  }

  useEffect(() => {
    if (cartData.length > 0) {
      cartData.forEach((item) => {
        if (item.supplement?.title === supplement?.title) {
          setItemAdded(true);
        }
      });
    }
  }, [cartData, supplement]);

  return (
    <div className="relative bg-mv-lightblue flex flex-col justify-between pb-4 rounded-lg shadow-lg max-w-md mx-auto">
      <div>
        <img
          src={supplement.product_image}
          alt="Couple on a cruise"
          className="w-full h-64 object-cover rounded-t-lg"
        />
        <div className="bg-mv-lightblue text-mv-darkblue p-6 rounded-b-lg">
          <h2 className="text-2xl font-bold mb-4">{supplement.title}</h2>
          <p className="mb-6 text-[#000] ">{supplement.short_description}</p>
        </div>
      </div>
      <div className="px-6">
        <div>
          <div className="flex gap-5 items-center mb-6">
            <span className="line-through text-[rgb(98,98,98)] text-lg">
              ${supplement.product_mrp}
            </span>
            <span className="text-2xl text-[#6699C2] font-bold">
              ${formatUSAmount(supplement.farecode_price)}
            </span>
            <span className="text-black italic">
              {getSelectionMethod(supplement.Selection_method) ||
                supplement.Selection_method}
            </span>
          </div>
          {supplement.child.product_mrp && child_count > 0 && (
            <div className="flex gap-5 items-center mb-6 -mt-5">
              <span className="line-through text-[rgb(98,98,98)] text-lg">
                ${supplement.child.product_mrp}
              </span>
              <span className="text-2xl text-[#6699C2] font-bold">
                ${formatUSAmount(supplement.child.farecode_price)}
              </span>
              <span className="text-black italic">
                {getSelectionMethod(supplement.child.Selection_method) ||
                  supplement.child.Selection_method}
              </span>
            </div>
          )}
        </div>
        <div className="flex justify-center gap-2 space-x-4">
          <button
            onClick={() => {
              if (islessthan3days(bookingDetails)) return;
              setShowAddToCartModal(true);
            }}
            className="bg-mv-darkblue hover:bg-blue-800 text-white font-bold py-2 px-2 md:px-4 rounded"
          >
            {itemAdded ? (
              <div className="flex gap-2 justify-center items-center">
                <svg
                  class="feather feather-edit"
                  fill="none"
                  height="20"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Edit
              </div>
            ) : (
              "ADD TO CART"
            )}
          </button>
          <button
            onClick={() => window.open(supplement.long_description, "_blank")}
            className="bg-white hover:bg-gray-200 text-blue-900 font-bold py-2 px-2 md:px-4 rounded border border-mv-darkblue"
          >
            LEARN MORE
          </button>
        </div>
      </div>
      {showAddToCartModal && (
        <div className="fixed bg-mv-backdrop z-10 bg-opacity-80 left-0 right-0 top-0 bottom-0 m-auto">
          <AddToCartModal
            bookingDetails={bookingDetails}
            min_qty={min_qty}
            max_qty={max_qty}
            child_min_qty={child_min_qty}
            child_max_qty={child_max_qty}
            child_count={child_count}
            guest_count={guest_count}
            supplement={supplement}
            _adults={
              cartData.find(
                (item) => item?.supplement?.title === supplement.title
              )?.adults
            }
            _children={
              cartData.find(
                (item) => item?.supplement?.title === supplement.title
              )?.children
            }
            setShowAddToCartModal={setShowAddToCartModal}
          />
        </div>
      )}
    </div>
  );
};

export default SupplementCard;
